import { api } from "../../../axios";

export interface DefaultDocument {
  document_key: string;
  title: string;
  description: string;
  enabled: boolean;
}

export interface DefaultDocumentsResponse {
  data: DefaultDocument[];
}

export const fetchDefaultDocuments = async (
  authToken: string
): Promise<DefaultDocumentsResponse> => {
  const response = await api.get(
    "bx_block_contentmanagement/document_templates/default_documents",
    { headers: { token: authToken } }
  );
  return response.data;
};

export const updateDefaultDocument = async (
  authToken: string,
  documentKey: string,
  enabled: boolean
): Promise<DefaultDocumentsResponse> => {
  const response = await api.patch(
    "bx_block_contentmanagement/document_templates/default_documents",
    { document_key: documentKey, enabled },
    { headers: { token: authToken } }
  );
  return response.data;
};
